import { render, staticRenderFns } from "./IGLoginButton.vue?vue&type=template&id=697b2449&scoped=true&"
import script from "./IGLoginButton.vue?vue&type=script&lang=js&"
export * from "./IGLoginButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697b2449",
  null
  
)

export default component.exports